import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../../../../_components/common/Navbar';
import CustomTableNew from '../../../../_components/common/CustomTableNew';
import { tables } from '../AssessmentSummaryTableData';
import TableNew from '../../../../_components/common/TableNew'
import Aux from '../../../../_components/common/Hoc';
import { getAssessmentReportAction } from '../../../../_actions/AssessmentSummary/getAssessmentReport.action';
import { RoleFitmentReportAction } from '../../../../_actions/organisations/roleFitmentReport/roleFitmentReport.action';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import { DropdownToggle, DropdownMenu, DropdownItem, Button, UncontrolledDropdown, CustomInput } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { getAssessementAction } from '../../../../_actions';
import { organisationAction } from '../../../../_actions/organisation.action';
import _ from 'lodash';
import { userRelationGroup } from '../../../../_actions';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import './index.css';

var respondent_progress_table_data = [{
    name: 'EMAIL',
    key: 'respondent__email',
    linkActive: false,
    link: '',
},
{
    name: 'SHORT NAME',
    key: 'respondent__short_name',
    linkActive: false,
    link: '',
},
{
    name: 'Relation',
    key: 'assessor_group__assessor_name',
    linkActive: false,
    link: '',
}, {
    name: 'Progress',
    key: 'respondent_completed_count_total_questions',
    linkActive: false,
    link: '',
}, {
    name: 'Extreme Response',
    key: 'extreame_response',
    type: 'extreame_response',
    linkActive: false,
    link: '',
}]

var respondent_progress_table_data_org_admin = [{
    name: 'EMAIL',
    key: 'respondent__email',
    linkActive: false,
    link: '',
},
{
    name: 'SHORT NAME',
    key: 'respondent__short_name',
    linkActive: false,
    link: '',
},
{
    name: 'Relation',
    key: 'assessor_group__assessor_name',
    linkActive: false,
    link: '',
}, {
    name: 'Progress',
    key: 'respondent_completed_count_total_questions',
    linkActive: false,
    link: '',
}]

class Assessment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            id: '',
            respondents: [],
            columnDataArr: [],
            showRoleData: false,
            holders: [],
            selectedHolder: 0,
            selectedFitment: 0,
            roleFitmentType: null,
            isAnyReportSelected: false,
            selectedReports: {},
            selectedOrientations: {
                Achievement: true,
                Relationship: true,
                Leadership: true,
                Learning: true,
                Nurturing: true
            }

        };
        this.orientationMapping = {
            Achievement: 2,
            Relationship: 5,
            Leadership: 1,
            Learning: 3,
            Nurturing: 4
        };

    }


    handleOrientationChange = (orientation) => {
        this.setState(prevState => {
            const newOrientations = {
                ...prevState.selectedOrientations,
                [orientation]: !prevState.selectedOrientations[orientation]
            };

            // Check if this action would uncheck the last selected orientation
            const selectedCount = Object.values(newOrientations).filter(Boolean).length;
            if (selectedCount === 0) {
                toast.error("At least one orientation must be selected.");
                // Return the previous state to prevent the change
                return prevState;
            }

            // If it's not the last one, allow the change
            return { selectedOrientations: newOrientations };
        });
    }



    componentDidMount() {

        let idFromPath = this.props.location.pathname.match(/\d/g);
        idFromPath = idFromPath.join("");

        const id = idFromPath

        const { dispatch } = this.props;


        let dataAssessment = {
            "batch_id": this.props.location.search.split('?organisation=')[1].split('&batch=')[1] == "unalloted" ? null : this.props.location.search.split('?organisation=')[1].split('&batch=')[1],
            "organisation_id": this.props.location.search.split('?organisation=')[1].split('&batch=')[0]
        }


        this.props.dispatch(getAssessementAction.getAssessementHandler(dataAssessment, (data_given) => {

            this.setState({
                columnDataArr: data_given.data.response
            }, () => {
                const columnDataArr = [...this.state.columnDataArr];
                let columnData = {
                    all: {}
                };
                columnDataArr.map(val => {
                    if (idFromPath == val.id) {
                        columnData = val
                    }
                })




                const data = {
                    'user_assessment': columnData.id,
                    'user': columnData.participant__id,
                    'screen_type': 'assessment_summary'
                }

                this.props.dispatch(userRelationGroup.userRelationGroupHandler(data))
                this.setState({
                    id
                })
            })
        }))

        dispatch(organisationAction.getOrganisation((callback_DataOrg) => {
            callback_DataOrg.data.organisation_list.map(val => {
                if (val.id == dataAssessment.organisation_id) {
                    let changeObj = {
                        "batch_id": this.props.location.search.split('?organisation=')[1].split('&batch=')[1] == "unalloted" ? 0 : this.props.location.search.split('?organisation=')[1].split('&batch=')[1],
                        "organisation_id": this.props.location.search.split('?organisation=')[1].split('&batch=')[0]
                    }
                    dispatch(getAssessmentReportAction.getAssessmentReportHandler({ ...changeObj, id, sellerId: val.seller__id }));
                }
            })
        }));




    }

    handleSelectAll = (checked) => {
        const selectedReports = {};
        [...this.props.presents, ...this.props.newRelationList].forEach(val => {
            selectedReports[val.id] = checked;
        });
        this.setState({
            isAnyReportSelected: checked,
            selectedReports
        });
    }

    handleReportSelection = (reportId, checked) => {
        this.setState(prevState => ({
            selectedReports: {
                ...prevState.selectedReports,
                [reportId]: checked
            },
            isAnyReportSelected: checked || Object.values(prevState.selectedReports).some(v => v)
        }));
    }

    handleOrientationSelection = (orientation, checked) => {
        this.setState(prevState => ({
            selectedOrientations: {
                ...prevState.selectedOrientations,
                [orientation]: checked
            }
        }));
    }
    handleDownload = (val, userId, columnData) => {
        const selectedOrientationIds = Object.entries(this.state.selectedOrientations)
            .filter(([key, value]) => value)
            .map(([key, value]) => this.orientationMapping[key]);

        localStorage.removeItem('download-obj');
        localStorage.setItem('download-obj', JSON.stringify({
            key: 'report',
            data: {
                data: val,
                user_assessment: parseInt(userId, 10),
                user: columnData.participant__id,
                orientation_list: selectedOrientationIds
            },
            screen_type: "assessment_summary"
        }));

        window.open(`/app/dashBoard/viewReport/${userId}/Download`, '_blank');

        this.setState({
            selectedOrientations: {
                Achievement: true,
                Relationship: true,
                Leadership: true,
                Learning: true,
                Nurturing: true
            }
        });


    }


    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    sellOrgDetails() {
        let data = [];
        data = [{
            'seller_name': this.props.assessmentReportResponse.seller_name,
            'organisation_name': this.props.assessmentReportResponse.organisation_name,
            'batch_name': this.props.assessmentReportResponse.batch_name,
        }]

        return data
    }

    componentDidUpdate(prevProps) {
        if (this.props.assessmentReportResponse !== prevProps.assessmentReportResponse) {
            if (this.props.assessmentReportResponse !== '') {
                if (this.props.assessmentReportResponse.length !== 0) {
                    let columnData = {
                        all: {}
                    };

                    let idFromPath = this.props.location.pathname.match(/\d/g);
                    idFromPath = idFromPath.join("");

                    const columnDataArr = [...this.state.columnDataArr];


                    columnDataArr.map(val => {
                        if (idFromPath == val.id) {
                            columnData = val
                        }
                    })

                    let respondents = [...this.props.assessmentReportResponse.respondents]

                    respondents.map(val => {
                        val["respondent_completed_count_total_questions"] = `${val.respondent_completed_count}/${val.user_assessment__assessment_number_count}`
                    })

                    this.setState({
                        respondents
                    })

                }
            }
        }
    }

    getAssessmentOverview() {
        let data = [];
        const columnDataArr = [...this.state.columnDataArr];
        let idFromPath = this.props.location.pathname.match(/\d/g);
        idFromPath = idFromPath.join("");
        let columnData = [];
        columnDataArr.map(val => {
            if (idFromPath == val.id) {
                columnData = val
            }
        })


        data = [{
            'instrument__instrument_name': [
                columnData.instrument__instrument_name,
                columnData.instrument__instrument_image
            ],
            'participant__email': columnData.participant__email,
            'participant__short_name': columnData.participant__short_name,
            'assessment_completed_count': columnData.assessment_completed_count,
            'respondent_count': columnData.respondent_completed + "/" + columnData.respondent_count,
            'is_submited': columnData.is_submited,
        }]





        return data
    }

    changeHolder = (selectedHolder) => {
        this.setState({
            selectedHolder
        })
    }

    changeFitment = (selectedFitment) => {
        this.setState({
            selectedFitment
        })
    }

    setRoleFitmentState = (updatedState) => {
        this.setState((state) => ({ ...state, ...updatedState }))
    }

    setRoleFitmentType = (roleFitmentType) => {
        this.setState({
            roleFitmentType
        })
    }

    render() {

        const { assessmentReportResponse, AssessmentReportLoading, AssessmentReportError } = this.props

        const columnDataArr = [...this.state.columnDataArr];
        let idFromPath = this.props.location.pathname.match(/\d/g);
        idFromPath = idFromPath.join("");
        let columnData = {
            all: {}
        };
        columnDataArr.map(val => {
            if (idFromPath == val.id) {
                columnData = val
            }
        })

        const roleFitmentReportData = {
            changeHolder: this.changeHolder,
            changeFitment: this.changeFitment,
            setRoleFitmentState: this.setRoleFitmentState,
            updateHoldersAndShowRoleData: this.updateHoldersAndShowRoleData,
            showRoleData: this.state.showRoleData,
            holders: this.state.holders,
            selectedHolder: this.state.selectedHolder,
            selectedFitment: this.state.selectedFitment,
            currentHolder: this.state.holders.find(item => item.id === this.state.selectedHolder),
            setState: this.setState,
            dispatch: this.props.dispatch
        }


        return (
            <div>
                <NavBar />

                <div className="container custom-container my-5" >


                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '/admin/app/assessment-summary',
                                    name: 'ASSESSMENT SUMMARY'
                                }, {
                                    link: '',
                                    name: 'ASSESSMENT DETAILS'
                                }
                            ]}
                        />
                    </div>

                    {

                        <Aux>
                            <div className="bg-green rounded-top position-relative mt-4 animation-fade-in">
                                {
                                    (AssessmentReportLoading) ?
                                        <div className="d-flex justify-content-between">
                                            <p></p>
                                            <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">SELLER & ORGANISATION DETAILS</p>
                                            <LoaderComp color={'white'} />
                                        </div>
                                        :
                                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">SELLER & ORGANISATION DETAILS</p>
                                }

                            </div>

                            <TableNew
                                data={this.sellOrgDetails()}
                                columns={tables.SellerOrgDetails}
                                showSlNo="false"

                            />

                            <div className="bg-green rounded-top position-relative mt-4 animation-fade-in">
                                {
                                    (AssessmentReportLoading) ?
                                        <div className="d-flex justify-content-between">
                                            <p></p>
                                            <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">ASSESSMENT OVERVIEW</p>
                                            <LoaderComp color={'white'} />
                                        </div>
                                        :
                                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">ASSESSMENT OVERVIEW</p>
                                }

                            </div>



                            {
                                columnData.instrument__is_multi_rater !== undefined &&
                                columnData.instrument__is_multi_rater === true &&
                                <TableNew
                                    data={this.getAssessmentOverview()}
                                    columns={tables.AssessmentOverviewForMultiRater}
                                    showSlNo="false"

                                />
                            }

                            {
                                columnData.instrument__is_multi_rater !== undefined &&
                                columnData.instrument__is_multi_rater === false &&
                                <TableNew
                                    data={this.getAssessmentOverview()}
                                    columns={tables.AssessmentOverviewForSingleRater}
                                    showSlNo="false"

                                />
                            }


                            {
                                assessmentReportResponse.respondents === [] &&
                                <Aux>
                                    <div className="bg-green rounded-top position-relative mt-4 animation-fade-in">
                                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">RESPONDENT PROGRESS</p>

                                    </div>

                                    <TableNew
                                        data={[]}
                                        columns={tables.RespondentsProgress}
                                        showSlNo="true"

                                    />
                                </Aux>
                            }

                            {
                                <Aux>
                                    <div style={{ textAlign: 'center' }}>
                                        <div className="bg-green rounded-top position-relative mt-4 animation-fade-in">
                                            <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">RESPONDENT PROGRESS</p>
                                        </div>

                                        {
                                            this.props.assessmentReportResponse !== '' &&
                                                this.props.assessmentReportResponse.respondents.length !== 0 ?
                                                <CustomTableNew
                                                    data={this.state.respondents}
                                                    columns={!localStorage.getItem('usertype').includes('organisation_admin') ? respondent_progress_table_data : respondent_progress_table_data_org_admin}
                                                    showSlNo="false"
                                                />
                                                :
                                                <p>This assessment has no respondents</p>

                                        }
                                    </div>
                                </Aux>
                            }
                            {
                                <Aux>
                                    {
                                        localStorage.getItem('usertype').split(',').includes('super_admin') || localStorage.getItem('usertype').split(',').includes('seller_admin') ?
                                            <TablePdfButtons roleFitmentType={this.state.roleFitmentType} setRoleFitmentType={this.setRoleFitmentType} roleFitmentReportData={roleFitmentReportData} userRelationGroupLoading={this.props.userRelationGroupLoading} userRelationGroupError={this.props.userRelationGroupError} columnData={columnData} userRelationGroupResponse={this.props.userRelationGroupResponse} enabledReports={this.props.userRelationGroupEnabledReports} assessmentReportResponse={this.props.assessmentReportResponse} userId={idFromPath} presents={this.props.presents}
                                                newRelationList={this.props.newRelationList}
                                                handleSelectAll={this.handleSelectAll}
                                                handleReportSelection={this.handleReportSelection}
                                                handleOrientationSelection={this.handleOrientationSelection}
                                                handleDownload={this.handleDownload}
                                                selectedReports={this.state.selectedReports}
                                                selectedOrientations={this.state.selectedOrientations}
                                                handleOrientationChange={this.handleOrientationChange}
                                                isAnyReportSelected={this.state.isAnyReportSelected}
                                                orientationMapping={this.orientationMapping}


                                                {...this.props} /> :
                                            null
                                    }
                                </Aux>
                            }
                        </Aux>
                    }

                </div>
            </div>
        );
    }
}

const TablePdfButtons = ({ roleFitmentType, setRoleFitmentType, roleFitmentReportData: {
    changeHolder,
    changeFitment,
    setRoleFitmentState,
    updateHoldersAndShowRoleData,
    showRoleData,
    holders,
    selectedHolder,
    selectedFitment,
    currentHolder,
    setState,
    dispatch
}, userRelationGroupLoading, userRelationGroupError, columnData, userRelationGroupResponse, enabledReports, userId, presents, handleSelectAll, handleReportSelection,
    handleOrientationSelection, handleDownload,
    orientationMapping,
    handleOrientationChange,
    selectedReports,
    selectedOrientations,
    isAnyReportSelected,
    assessmentReportResponse, ...props }) => {
    const relationList = Object.keys(userRelationGroupResponse).length !== 0 ? userRelationGroupResponse.relation_list : []
    const devList = Object.keys(userRelationGroupResponse).length !== 0 ? userRelationGroupResponse.dev_plan_list !== undefined ? userRelationGroupResponse.dev_plan_list : [] : []
    let relationListCompared = [];




    const mappedRelationList = relationList.map(relation => ({
        relation_group_id: relation.relation_group_id,
        relation_group_name: relation.relation_group_name
    }))

    const mappedEnabledReports = Array.isArray(enabledReports) ? enabledReports.map(reports => ({
        relation_group_id: reports.relation_group_id,
        relation_group_name: reports.relation_group_name
    })) : []

    var presents = _.intersectionWith(mappedEnabledReports, mappedRelationList, _.isEqual);
    var dif2 = _.differenceWith(mappedRelationList, presents, _.isEqual);

    const newRelationList = dif2.map(val => {
        val["htmlRelationName"] = userRelationGroupResponse.filter
            ? `<div style="display: flex;"><p style="margin: 0;">${val.relation_group_name}</p> <p style="color: red;margin:0;margin-left: 10px;">**</p></div>`
            : `<div style="display: flex;"><p style="margin: 0;" class="onHvrUnderline">${val.relation_group_name}</p> <p style="color: red;margin:0;margin-left: 10px;">**</p></div>`;
        return val;
    });

    presents.map(val => {
        val["htmlRelationName"] = userRelationGroupResponse.filter
            ? `<div style="display: flex;"><p style="margin: 0;">${val.relation_group_name}</p></div>`
            : `<div style="display: flex;"><p style="margin: 0;" class="onHvrUnderline">${val.relation_group_name}</p></div>`;
    });




    let ifOneRespCompleted = false

    assessmentReportResponse.respondents !== undefined &&
        assessmentReportResponse.respondents.length !== 0 &&
        assessmentReportResponse.respondents.map(val => {
            if (val.respondent_completed_count === columnData.assessment_number_count) {
                ifOneRespCompleted = true
            }
        })


    const handleDownloadClick = (e, val) => {
        e.preventDefault(); // Prevent the default link behavior
        handleDownload(val, userId, columnData);
    };






    return (
        <div style={{ textAlign: 'center' }}>
            <div className="bg-green rounded-top position-relative mt-4 animation-fade-in">
                <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">REPORTS</p>
            </div>
            {
                showRoleData ?
                    <div style={{ width: "50%", margin: "auto" }}>
                        <p style={{ fontSize: "24px", textAlign: "center" }}>Role fitment report</p>
                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                            <div style={{
                                flex: "1",
                                padding: "1rem",
                                border: "1px solid #eee",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}>
                                <p className="centered-text">Category</p>
                                <div>
                                    {
                                        holders.map(item => {
                                            return (
                                                <CustomInput

                                                    style={{ margin: "0.6rem 0" }}
                                                    onChange={() => changeHolder(item.id)}
                                                    type="radio"
                                                    name="holderRadio"
                                                    id={item.holder_name}
                                                    label={item.holder_name}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div style={{
                                flex: "1",
                                padding: "1rem",
                                border: "1px solid #eee",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}>
                                <p className="centered-text" style={{ marginBottom: "1rem" }}>Reports</p>{/* increased bottom margin */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    {currentHolder
                                        ? currentHolder.fitments.map((item) => (
                                            <div
                                                key={item.id}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "0.5rem"
                                                }}
                                            >
                                                <input
                                                    type="radio"
                                                    id={`radio-${item.id}`}
                                                    name="fitmentRadio"
                                                    value={item.id}
                                                    onChange={() => changeFitment(item.id)}
                                                    style={{ marginRight: "0.5rem" }}
                                                />
                                                <label htmlFor={`radio-${item.id}`} style={{ margin: 0 }}>
                                                    {item.name}
                                                </label>
                                            </div>
                                        ))
                                        : null}
                                </div>
                            </div>
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-around"
                        }}>
                            <Link onClick={(e) => {
                                if (!selectedHolder || !selectedFitment) {
                                    e.preventDefault();
                                } else {
                                    localStorage.removeItem('download-obj');
                                    localStorage.setItem('download-obj', JSON.stringify({
                                        key: roleFitmentType,
                                        data: {
                                            'user_assessment_ids': [parseInt(userId, 10)],
                                            'holder_id': selectedHolder,
                                            'fitment_id': selectedFitment,
                                            'org_id': userRelationGroupResponse.organisation
                                        }
                                    }))
                                }
                            }} disabled={!selectedHolder || !selectedFitment}
                                className="btn buttonColor"
                                style={{
                                    color: 'white',
                                    borderColor: 'red',
                                    opacity: (!selectedFitment || !selectedHolder) ? 0.4 : 1,
                                    marginTop: "10px"
                                }}
                                to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >Download</Link>
                            <Button
                                style={{ marginTop: 10, float: "right" }}
                                onClick={() => {
                                    setRoleFitmentType(null);
                                    setRoleFitmentState({
                                        holders: [],
                                        selectedFitment: 0,
                                        selectedHolder: 0,
                                        showRoleData: false
                                    })
                                }}>Back</Button>
                        </div>
                    </div>
                    :
                    !userRelationGroupLoading && !userRelationGroupError ?
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingTop: 10 }}>
                            {
                                !columnData.instrument__is_multi_rater ?
                                    columnData.instrument__instrument_name === 'VVI' ?
                                        <Link
                                            onClick={
                                                () => {
                                                    localStorage.removeItem('download-obj');
                                                    localStorage.setItem('download-obj', JSON.stringify({
                                                        key: 'VVI',
                                                        data: {
                                                            data: userRelationGroupResponse,
                                                            'user_assessment': parseInt(userId, 10),
                                                            'user': columnData.participant__id
                                                        }
                                                    }))
                                                }
                                            }
                                            className="btn buttonColor"
                                            style={{ color: 'white', borderColor: 'red' }}
                                            to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >
                                            Download Report
                                        </Link>
                                        :
                                        <React.Fragment>
                                            <UncontrolledDropdown>
                                                <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                    Download Report
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    {userRelationGroupResponse.filter ? (
                                                        // Render this when filter is true
                                                        <UncontrolledDropdown  >
                                                            <DropdownToggle tag="div" className="w-100" style={{ cursor: 'pointer', borderBottom: '1px solid #e0e0e0' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
                                                                    <span>Self Report</span>
                                                                    <span>▶</span>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu style={{ width: '300px', maxWidth: '100%', padding: '0' }}>
                                                                {Object.keys(orientationMapping).map((orientation) => (
                                                                    <DropdownItem key={orientation} toggle={false}  >
                                                                        <label className='assessmentSummary-checkbox' style={{ display: 'flex', alignItems: 'center', margin: '0', cursor: 'pointer' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedOrientations[orientation]}
                                                                                onChange={() => handleOrientationChange(orientation)}
                                                                                style={{ marginRight: '10px' }}
                                                                            />
                                                                            <span>{orientation}</span>
                                                                        </label>
                                                                    </DropdownItem>
                                                                ))}
                                                                <DropdownItem style={{ background: '#ee6552' }}>
                                                                    <Link
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            const selectedOrientationIds = Object.entries(selectedOrientations)
                                                                                .filter(([key, value]) => value)
                                                                                .map(([key, value]) => orientationMapping[key]);

                                                                            localStorage.removeItem('download-obj');
                                                                            localStorage.setItem('download-obj', JSON.stringify({
                                                                                key: 'self-report',
                                                                                screen_type: "assessment_summary",
                                                                                data: {
                                                                                    user_assessment: parseInt(userId, 10),
                                                                                    user: columnData.participant__id,
                                                                                    orientation_list: selectedOrientationIds,
                                                                                    relation_group_id: 28,
                                                                                    relation_group_name: "Self report"
                                                                                },
                                                                            }));
                                                                            window.open(`/app/dashBoard/viewReport/${userId}/Download`, '_blank');
                                                                        }}
                                                                        style={{ color: 'white', textDecoration: 'none', display: 'block', width: '100%' }}
                                                                        to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }}
                                                                        target="_blank"
                                                                        className="removeUnderline"
                                                                    >
                                                                        Download
                                                                    </Link>
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    ) : (
                                                        // Render this when filter is false
                                                        <DropdownItem>
                                                            <Link
                                                                onClick={() => {
                                                                    localStorage.removeItem('download-obj');
                                                                    localStorage.setItem('download-obj', JSON.stringify({
                                                                        key: 'self-report',
                                                                        screen_type: "assessment_summary",
                                                                        data: {
                                                                            data: userRelationGroupResponse,
                                                                            'user_assessment': parseInt(userId, 10),
                                                                            'user': columnData.participant__id,
                                                                            relation_group_id: 28,
                                                                            relation_group_name: "Self report"
                                                                        },
                                                                    }))
                                                                }}
                                                                style={{ color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }}
                                                                target="_blank"
                                                            >
                                                                Self Report
                                                            </Link>
                                                        </DropdownItem>
                                                    )}
                                                    {enabledReports.some(item => item.relation_group_id === 30) && (
                                                        <DropdownItem>
                                                            <Link
                                                                onClick={() => {
                                                                    const downloadObj = {
                                                                        key: 'self_student',
                                                                        screen_type: "assessment_summary",
                                                                        data: {
                                                                            data: userRelationGroupResponse,
                                                                            'user_assessment': parseInt(userId, 10),
                                                                            'user': columnData.participant__id,
                                                                        },
                                                                    };

                                                                    localStorage.removeItem('download-obj');
                                                                    localStorage.setItem('download-obj', JSON.stringify(downloadObj));
                                                                }}
                                                                style={{ color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >
                                                                Self Report - Student
                                                            </Link>
                                                        </DropdownItem>
                                                    )}




                                                    <DropdownItem>
                                                        <Link
                                                            style={{ color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                            onClick={
                                                                (e) => {
                                                                    e.preventDefault();
                                                                    dispatch(RoleFitmentReportAction.getAllotedOrganisationFitmentsAction({ orgId: userRelationGroupResponse.organisation }, (holders) => {
                                                                        setRoleFitmentType("ROLE_FITMENT")
                                                                        setRoleFitmentState({
                                                                            holders: holders.data.holders,
                                                                            showRoleData: true
                                                                        })
                                                                    }))
                                                                }
                                                            }
                                                            to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >
                                                            Role fitment report
                                                        </Link>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                            {
                                                devList.length !== 0 &&
                                                userRelationGroupResponse.dev_plan__development_plan_name !== '' &&
                                                <UncontrolledDropdown>
                                                    <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                        Development Plan
                                                    </DropdownToggle>
                                                    <DropdownMenu>

                                                        {
                                                            devList.map(val => {
                                                                return (
                                                                    <DropdownItem>
                                                                        <Link
                                                                            onClick={
                                                                                () => {
                                                                                    localStorage.removeItem('download-obj');
                                                                                    localStorage.setItem('download-obj', JSON.stringify({
                                                                                        key: 'selfDevPlan',
                                                                                        data: {
                                                                                            data: val,
                                                                                            'user_assessment': parseInt(userId, 10),
                                                                                            'user': columnData.participant__id
                                                                                        }
                                                                                    }))
                                                                                }
                                                                            }
                                                                            style={{ background: "#fff", color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                            to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >
                                                                            {val.development_plan_name}
                                                                        </Link>
                                                                    </DropdownItem>
                                                                )
                                                            })
                                                        }

                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            }
                                        </React.Fragment>
                                    :
                                    <React.Fragment>

                                        {
                                            relationList.length !== 0 &&
                                            <UncontrolledDropdown >
                                                <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                    Download Report
                                                </DropdownToggle>

                                                <DropdownMenu>
                                                    {userRelationGroupResponse.filter ? (
                                                        // Render this when filter is true

                                                        [...presents, ...newRelationList].map((val, index, array) => (
                                                            <UncontrolledDropdown key={val.id} direction='right'
                                                            className={`${index === 0 ? 'first-item' : ''} ${array.length - index <= 5 ? 'last-five-dropdown' : ''}`}


                                                            >
                                                                {val.relation_group_name === "Competency" || val.relation_group_name === "Value" ? (
                                                                    // For Competency and Value, entire area is clickable
                                                                    <div
                                                                        className="loi360border"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            padding: '3px',  // Match DropdownToggle padding

                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleDownloadClick(e, val);
                                                                        }}
                                                                    >
                                                                        <span style={{ whiteSpace: 'nowrap', textDecoration: 'none !important' }}>
                                                                            {ReactHtmlParser(val.htmlRelationName)}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    // For all other relation groups, keep existing dropdown behavior
                                                                    <DropdownToggle tag="div" className="loi360border">
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                            <span style={{ whiteSpace: 'nowrap', textDecoration: 'none !important' }}>
                                                                                {ReactHtmlParser(val.htmlRelationName)}
                                                                            </span>
                                                                            {val.relation_group_id === 32 ? (
                                                                                <div
                                                                                    style={{ color: "#007bff", cursor: 'pointer' }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        dispatch(RoleFitmentReportAction.getAllotedOrganisationFitmentsAction(
                                                                                            { orgId: userRelationGroupResponse.organisation },
                                                                                            (holders) => {
                                                                                                setRoleFitmentType("ROLE_FITMENT_LOI");
                                                                                                setRoleFitmentState({
                                                                                                    holders: holders.data.holders,
                                                                                                    showRoleData: true
                                                                                                });
                                                                                            }
                                                                                        ));
                                                                                    }}
                                                                                >
                                                                                    Download
                                                                                </div>
                                                                            ) : (
                                                                                <span>▶</span>
                                                                            )}
                                                                        </div>
                                                                    </DropdownToggle>
                                                                )}
                                                                {val.relation_group_id !== 32 && val.relation_group_name !== "Competency" && val.relation_group_name !== "Value" && (
                                                                    <DropdownMenu style={{ paddingBottom: 0, width: '300px', maxWidth: '100%' }}>
                                                                        {Object.keys(orientationMapping).map((orientation) => (
                                                                            <DropdownItem key={orientation} toggle={false}>
                                                                                <label className='assessmentSummary-checkbox' style={{ cursor: 'pointer' }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectedOrientations[orientation]}
                                                                                        onChange={() => handleOrientationChange(orientation)}
                                                                                    /> {orientation}
                                                                                </label>
                                                                            </DropdownItem>
                                                                        ))}
                                                                        <DropdownItem style={{ background: '#ee6552' }}>
                                                                            <Link
                                                                                onClick={(e) => handleDownloadClick(e, val)}
                                                                                style={{ textAlign: "left", border: "none", padding: 0 }}
                                                                                to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }}
                                                                                target="_blank"
                                                                                className="removeUnderline"
                                                                            >
                                                                                Download
                                                                            </Link>
                                                                        </DropdownItem>
                                                                    </DropdownMenu>
                                                                )}
                                                            </UncontrolledDropdown>
                                                        ))
                                                    ) : (
                                                        // Render this when filter is false
                                                        [...presents, ...newRelationList].map(val => (
                                                            <DropdownItem key={val.id}>
                                                                {val.relation_group_id === 32 ? (
                                                                    <div style={{ color: "#007bff", cursor: 'pointer' }} onClick={() => {
                                                                        dispatch(RoleFitmentReportAction.getAllotedOrganisationFitmentsAction({ orgId: userRelationGroupResponse.organisation }, (holders) => {
                                                                            setRoleFitmentType("ROLE_FITMENT_LOI")
                                                                            setRoleFitmentState({
                                                                                holders: holders.data.holders,
                                                                                showRoleData: true
                                                                            })
                                                                        }))
                                                                    }}>
                                                                        {ReactHtmlParser(val.htmlRelationName)}
                                                                    </div>
                                                                ) : (
                                                                    <Link
                                                                        onClick={() => {
                                                                            localStorage.removeItem('download-obj');
                                                                            localStorage.setItem('download-obj', JSON.stringify({
                                                                                key: 'report',
                                                                                data: {
                                                                                    data: val,
                                                                                    'user_assessment': parseInt(userId, 10),
                                                                                    'user': columnData.participant__id
                                                                                },
                                                                                screen_type: "assessment_summary"
                                                                            }))
                                                                        }}
                                                                        style={{ color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                        to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }}
                                                                        target="_blank"
                                                                        className="removeUnderline"
                                                                    >
                                                                        {ReactHtmlParser(val.htmlRelationName)}
                                                                    </Link>
                                                                )}
                                                            </DropdownItem>
                                                        ))
                                                    )}
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        }
                                        {
                                            ifOneRespCompleted &&
                                            <Link
                                                onClick={
                                                    () => {
                                                        localStorage.removeItem('download-obj');
                                                        localStorage.setItem('download-obj', JSON.stringify({
                                                            key: 'vpiRawScore',
                                                            data: {
                                                                data: userRelationGroupResponse,
                                                                'user_assessment': parseInt(userId, 10),
                                                                'user': columnData.participant__id
                                                            }
                                                        }))
                                                    }
                                                }
                                                className="btn buttonColor"
                                                style={{ color: 'white', borderColor: 'red' }}
                                                to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }}
                                                target="_blank" >
                                                VPI RAW SCORE
                                            </Link>
                                        }
                                        {
                                            devList.length !== 0 &&
                                            userRelationGroupResponse.dev_plan__development_plan_name !== '' &&
                                            <UncontrolledDropdown>
                                                <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                    Development Plan
                                                </DropdownToggle>
                                                <DropdownMenu>

                                                    {
                                                        devList.map(val => {
                                                            return (
                                                                <DropdownItem>
                                                                    <Link
                                                                        onClick={
                                                                            () => {
                                                                                localStorage.removeItem('download-obj');
                                                                                localStorage.setItem('download-obj', JSON.stringify({
                                                                                    key: 'plan',
                                                                                    data: {
                                                                                        data: val,
                                                                                        'user_assessment': parseInt(userId, 10),
                                                                                        'user': columnData.participant__id
                                                                                    }
                                                                                }))
                                                                            }
                                                                        }
                                                                        style={{ color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                        to={{ pathname: `/app/dashBoard/viewReport/${userId}/Download` }} target="_blank" >
                                                                        {val.development_plan_name}
                                                                    </Link>
                                                                </DropdownItem>
                                                            )
                                                        })
                                                    }

                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        }
                                    </React.Fragment>
                            }
                            {
                                devList.length === 0 && !ifOneRespCompleted && relationList.length === 0 && columnData.instrument__is_multi_rater &&
                                <p>This assessment has no reports available at this time.</p>
                            }
                        </div>
                        :
                        <p>This assessment has no reports available at this time.</p>
            }
        </div>
    )
}


function mapStateToProps(state) {

    const { AssessmentReportLoading } = state.getAssessmentReport;
    const { error } = state.getAssessmentReport;
    const assessmentReportResponse = (!AssessmentReportLoading && !error) ? state.getAssessmentReport.data.data.response : '';

    const { userRelationGroupLoading } = state.userRelationGroupReducer;
    const userRelationGroupError = state.userRelationGroupReducer.error;
    const userRelationGroupResponse = (!userRelationGroupLoading && !userRelationGroupError) ? state.userRelationGroupReducer.data.data.data : {};
    const userRelationGroupEnabledReports = (!userRelationGroupLoading && !userRelationGroupError) ? state.userRelationGroupReducer.data.data.enabled_reports : {};

    return {
        userRelationGroupLoading,
        userRelationGroupResponse,
        userRelationGroupEnabledReports,

        AssessmentReportLoading,
        assessmentReportResponse,
        AssessmentReportError: error,
        userRelationGroupError,

    };
}

export default connect(mapStateToProps)(Assessment);


// WEBPACK FOOTER //
// ./src/_pages/Admin/AssessmentSummary/Assessment/index.jsx